import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { AdSupplierUser } from '@magnetar/data-access'

interface AdSupplierUserResponse {
  success: boolean
  data: AdSupplierUser | null
  error?: {
    code: string
    message: string
  }
}

interface CreateNewUserAndAddToSupplierRequest {
  supplier_id: number
  account: string
  user_name: string
  email?: string
  user_role_id?: number
  /** 廣告商超級管理員（只有管理端能指定） */
  is_super_admin?: boolean
}

interface UpdateAdSupplierUserRequest {
  supplier_id: number
  user_id: number
  user_role_id?: number | null
  is_super_admin?: boolean
}

export const adSupplierUsersService = {
  updateAdSupplierUser: async (
    supplier_id: number,
    id: number,
    data: UpdateAdSupplierUserRequest,
    token: string,
  ): Promise<AdSupplierUserResponse> => {
    try {
      const response = await apiClient.put<AdSupplierUserResponse>(
        `/api/ad-supplier/${supplier_id}/users/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as AdSupplierUserResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'UPDATE_AD_SUPPLIER_USER_FAILED',
          message: '更新供應商使用者失敗',
        },
      }
    }
  },

  // createAdSupplierUser: async (
  //   data: CreateAdSupplierUserRequest,
  //   token: string,
  // ): Promise<AdSupplierUserResponse> => {
  //   try {
  //     const response = await apiClient.post<AdSupplierUserResponse>(
  //       '/api/ad-supplier-users',
  //       data,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       },
  //     )
  //     return response.data
  //   } catch (error) {
  //     if (axios.isAxiosError(error) && error.response) {
  //       return error.response.data as AdSupplierUserResponse
  //     }
  //     return {
  //       success: false,
  //       data: null,
  //       error: {
  //         code: 'CREATE_AD_SUPPLIER_USER_FAILED',
  //         message: '建立供應商使用者失敗',
  //       },
  //     }
  //   }
  // },

  deleteAdSupplierUser: async (
    supplier_id: number,
    id: number,
    token: string,
  ): Promise<AdSupplierUserResponse> => {
    try {
      const response = await apiClient.delete<AdSupplierUserResponse>(
        `/api/ad-supplier/${supplier_id}/users/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as AdSupplierUserResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'DELETE_AD_SUPPLIER_USER_FAILED',
          message: '刪除供應商使用者失敗',
        },
      }
    }
  },

  createNewUserAndAddToSupplier: async (
    data: CreateNewUserAndAddToSupplierRequest,
    token: string,
  ): Promise<AdSupplierUserResponse> => {
    try {
      const response = await apiClient.post<AdSupplierUserResponse>(
        `/api/ad-supplier/${data.supplier_id}/users`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as AdSupplierUserResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'CREATE_NEW_USER_FAILED',
          message: '建立新使用者失敗',
        },
      }
    }
  },
}
